<script>
export default {
  name: "WritingSkill",
  props: {
    data: {
      type: Object,
      default: null
    },
    isImport: {
      type: Boolean,
      default: false
    },
    isOffline: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    answers(question) {
      const answer = question?.answer
      return (Array.isArray(answer) ? answer : [answer])
        .filter(item => typeof item === 'string' && item.trim())
        .map(item => item.trim())
    },
    isImageAnswer(value) {
      return /^(?:(?:https?:)?\/\/|data:image\/|blob:)\S+$/i.test(value) || /\.(?:jpe?g|png|gif|webp|bmp|svg)(?:\?.*)?$/i.test(value)
    },
    answerImages(question) {
      return this.answers(question).filter(item => this.isImageAnswer(item))
    },
    answerTexts(question) {
      return this.answers(question).filter(item => !this.isImageAnswer(item))
    }
  }
}
</script>

<template>
  <div class="w-100">
    <div v-if="!data">
      <p style="font-weight: bold"> Chưa có dữ liệu bài thi viết</p>
    </div>
    <div v-else class="mt-3 p-5" style="background-color: #F8F8F8">
      <p style="font-weight: bold">Kĩ năng: Viết</p>
      <div v-for="(question,questionIndex) in data?.questions" :key="question?.id" style="background-color: #F8F8F8">
        <p style="font-weight: bold">Câu {{ questionIndex + 1 }}:</p>
        <p id="midterm-test" v-html="question?.question"></p>
        <div v-if="answerImages(question).length" class="d-flex">
          <div class="ml-4" v-for="(imgUrl, imageIndex) in answerImages(question)" :key="imageIndex">
            <el-image
                style="width: 100px; height: 100px"
                :src="imgUrl"
                :preview-src-list="[imgUrl]">
            </el-image>
          </div>
        </div>
        <div v-if="answerTexts(question).length" style="background-color: white ; text-align: justify" class="p-5">
          <p v-for="(answer, answerIndex) in answerTexts(question)" :key="answerIndex">{{ answer }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
